module.exports = __webpack_public_path__ + "static/media/Sleepyhead.8131443e.jpg";